var _style, _path, _path2, _polygon, _path3, _path4, _path5, _path6, _polygon2, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180.2 55.4",
    style: {
      enableBackground: "new 0 0 180.2 55.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#203370;}\n\t.st1{fill:#4BA38C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.4,17.1h5.8v3.5c1.6-2.7,4.5-4.1,8.2-4.1c6,0,9.1,3.4,9.1,9.9v15.7h-5.8v-13c0-5.3-1.4-7.6-5.5-7.6 c-3.8,0-6,2.5-6,6.9v13.7H0.4V17.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.9,31.5H31.4c0.2,4,2.7,6.1,7,6.1c2.9,0,4.6-0.9,5.6-2.8h5.9c-0.8,4.7-5.5,7.9-11.5,7.9 c-7.9,0-12.8-5-12.8-13.1c0-8,4.9-13.1,12.6-13.1c7.1,0,12,4.8,12,11.9C50.1,29.3,50,30.1,49.9,31.5 M44.4,27.1 c-0.1-3.9-2.3-6-6.3-6c-4.1,0-6.6,2.5-6.7,6H44.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57.8,29.5 48.7,17.1 55.9,17.1 61.2,25.2 66.4,17.1 73.6,17.1 64.5,29.5 73.8,42.1 66.5,42.1  61.2,33.7 55.8,42.1 48.5,42.1 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87,29.6c0-7.8,4.7-13.1,12.4-13.1c7,0,11.3,3.8,11.9,9.5h-5.8c-0.6-2.8-2.5-4.3-6-4.3c-4.1,0-6.6,2.8-6.6,7.9 c0,5.1,2.5,7.9,6.6,7.9c3.5,0,5.4-1.4,6-4.1h5.8c-0.5,5.6-4.9,9.3-11.9,9.3C91.7,42.7,87,37.4,87,29.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.9,29.6c0-7.3,4.7-13.1,12.4-13.1c3.3,0,6.3,1.5,7.9,4v-3.4h5.8v25h-5.8v-3.4c-1.6,2.5-5,4-8,4 C116.2,42.7,111.9,36.9,111.9,29.6 M132.5,29.6c0-4.3-2.4-7.9-7.4-7.9c-4.6,0-7.3,3.4-7.3,7.9c0,4.6,2.7,7.9,7.3,7.9 C130,37.5,132.5,33.9,132.5,29.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.3,17.1h5.8v4.8c0.9-3.5,3.9-5.1,6.7-5.1c0.9,0,1.7,0.1,2.3,0.2v5.4c-0.9-0.1-1.4-0.1-2.3-0.1 c-4.1,0-6.7,3.1-6.7,8.8v11.1h-5.8V17.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180,31.5h-18.6c0.2,4,2.7,6.1,7,6.1c2.9,0,4.6-0.9,5.6-2.8h5.9c-0.8,4.7-5.5,7.9-11.5,7.9 c-7.9,0-12.8-5-12.8-13.1c0-8,4.9-13.1,12.6-13.1c7.1,0,12,4.8,12,11.9C180.2,29.3,180.1,30.1,180,31.5 M174.5,27.1 c-0.1-3.9-2.3-6-6.3-6c-4.1,0-6.6,2.5-6.7,6H174.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80.6,11.3 74.8,11.3 74.8,17.1 74.8,22 74.8,22.9 86.5,22.9 86.5,17.1 80.6,17.1 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.3,37.2c-2.3,0-3.6-0.5-3.6-4.9V23h-5.8v10.7c0,8.4,5.3,8.8,8.1,8.8c1.7,0,3.4-0.2,4.3-0.3v-5.2 C86.6,37.1,85.2,37.2,84.3,37.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextCare);
export default __webpack_public_path__ + "static/media/NextCare.561f126ea2cec675c0947ba1bca88d26.svg";
export { ForwardRef as ReactComponent };